<div class="d-inline-flex align-items-center">
  <form (submit)="onSubmit($event)">
    <!-- accessibility username felt -->
    <input type="hidden" type="text" autocomplete="username" [hidden]="true"> 
    <div class="input-group">
      <label class="input-group-text" for="passwordInput"  id="passwordlabel">Sæt administrator kodeord:</label>
      <input type="password" autocomplete="new-password" class="form-control" id="passwordInput" aria-describedby="passwordlabel" style="max-width: 400px; min-width: 200px;"
        [formField]="passwordForm.password">
      <button class="btn btn-primary" type="submit" [disabled]="passwordForm().invalid()">Sæt kodeord</button>
    </div>
    @if (passwordForm.password().invalid() && passwordForm.password().touched()) {
      <div class="text-danger">Dit password skal overholde følgende:</div>
      <ul class="text-danger">
        @for (error of passwordForm.password().errors(); track $index) {
          <li>{{ error.message }}</li>
        }
      </ul>
    }
  </form>
  <i title="Administrator kodeord overskriver dit kodeord for alle dine logins til forskellige kunder, på nuværende miljø.
Administrator passwords har altid de højeste password krav.
Password krav:
• Password skal udfyldes.
• Password skal være mindst 7 tegn langt.
• Password skal indeholde mindst et tal.
• Password skal indeholde mindst et lille bogstav.
• Password skal indeholde mindst et stort bogstav.
• Password skal indeholde mindst et specialtegn. (½!&quot;#¤%&amp;/()=?§@£$€{}[])"
    class="ms-2 fa-light fa-circle-question align-self-start mt-2" ></i>
</div>